export default __webpack_public_path__ + "static/media/ic_bar_left_home.cfdb4482.svg";